import Tag from '../Projects/Tag'

import { useTranslation } from 'react-i18next'

type Props = {
  experience: {
    name: string
    title: string
    description: string
    tags?: string[]
    periodStart: string
    periodEnd: string
  }
}

export default function ExperienceItem({ experience }: Props) {
  const { i18n } = useTranslation()
  const locale = i18n.resolvedLanguage
  const { name, description, tags, title, periodEnd, periodStart } = experience
  const dates = `${new Date(periodStart).toLocaleDateString(locale, {
    year: 'numeric',
    month: 'short',
  })} - ${new Date(periodEnd).toLocaleDateString(locale, {
    year: 'numeric',
    month: 'short',
  })}`
  return (
    <li className='lg:px-6 py-8 lg:hover:bg-neutral-200/60 lg:dark:hover:bg-neutral-700 rounded-md transition duration-300 ease-in-out lg:flex'>
      <div className='experience-date'>{dates}</div>
      <div className='lg:ml-8 grow lg:mt-0 mt-3'>
        <div className='flex items-baseline'>
          <h3 className='font-semibold text-lg mr-3'>
            {title}, {name}
          </h3>
        </div>
        <p className='font-light'>{description}</p>
        {tags?.length && (
          <ul className='flex flex-wrap'>
            {tags.map((tag) => (
              <Tag key={tag} tag={tag} />
            ))}
          </ul>
        )}
      </div>
    </li>
  )
}
